import easyToggle from "easy-toggle-state";
import { TextareaAutoSize } from "textarea-autosize";

import Header from "./blocks/Header";
import ReviewsBox from "./blocks/ReviewsBox";
import ValidationWrap from "./blocks/ValidationWrap";
import TickerLogos from "./blocks/TickerLogos";
import MainIntro from "./blocks/MainIntro";
import ArticleWrap from "./blocks/ArticleWrap";

const initScripts = () => {
	easyToggle();

	const textareas = document.querySelectorAll("textarea.js-auto-size");
	if (textareas.length) {
		textareas.forEach((textarea) => {
			new TextareaAutoSize(textarea);
		});
	}

	const handleScrollLink = (e) => {
		e.preventDefault();
		const target = document.querySelector(e.target.getAttribute("href"));
		const header = document.querySelector(".header");

		if (target) {
			gsap.to(window, {
				duration: 1,
				scrollTo: {
					y: target,
					offsetY: header.offsetHeight + 20
				}
			});
		}
	};

	document.querySelectorAll(".scroll-link").forEach((link) => {
		link.addEventListener("click", (e) => {
			handleScrollLink(e);
		});
	});

	// form field blur state
	const formFields = document.querySelectorAll(".form-control");
	formFields.forEach((field) => {
		field.addEventListener("focus", function(e) {
			e.target.closest(".form-group").classList.add("has-value");
		});

		field.addEventListener("blur", function(e) {
			if (!e.target.value) {
				e.target.closest(".form-group").classList.remove("has-value");
			}
		});
	});
};

initScripts();
Header();
ReviewsBox();
ValidationWrap();
TickerLogos();
MainIntro();
ArticleWrap();